function getEffectiveMentioned(conversationType) {
    return conversationType.GlobalMentionedMe || conversationType.GlobalAtAllMention;
}
export default function mapConversationTypeToConversationRelation(conversationType) {
    return {
        categories: conversationType.Categories,
        charm: conversationType.Charm ? conversationType.Charm : 'None',
        draftItemIds: conversationType.DraftItemIds
            ? conversationType.DraftItemIds.map(function (baseDraftItemId) { return baseDraftItemId.Id; })
            : [],
        effectiveMentioned: getEffectiveMentioned(conversationType),
        executeSearchSortOrder: conversationType.SortOrderSource,
        flagStatus: conversationType.FlagStatus,
        hasAttachments: conversationType.HasAttachments,
        hasIrm: conversationType.HasIrm,
        iconIndex: conversationType.IconIndex,
        id: conversationType.ConversationId.Id,
        importance: conversationType.Importance,
        instanceKey: conversationType.InstanceKey,
        itemClasses: conversationType.ItemClasses,
        itemIds: conversationType.ItemIds.map(function (baseItemId) { return baseItemId.Id; }),
        lastDeliveryOrRenewTimeStamp: conversationType.LastDeliveryOrRenewTime,
        lastDeliveryTimeStamp: conversationType.LastDeliveryTime,
        lastModifiedTimeStamp: conversationType.LastModifiedTime,
        lastSender: conversationType.LastSender
            ? conversationType.LastSender
            : conversationType.From,
        parentFolderId: conversationType.ParentFolderId ? conversationType.ParentFolderId.Id : null,
        previewText: conversationType.Preview,
        returnTime: conversationType.ReturnTime ? conversationType.ReturnTime : null,
        systemCategories: conversationType.SystemCategories,
        uniqueRecipients: conversationType.UniqueRecipients,
        uniqueSenders: conversationType.UniqueSenders,
        unreadCount: conversationType.UnreadCount,
        globalLikeCount: conversationType.GlobalLikeCount ? conversationType.GlobalLikeCount : null,
    };
}
//# sourceMappingURL=mapConversationTypeToConversationRelation.js.map